import React from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  CardTitle,
  Table,
} from "reactstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DatePicker from "react-datepicker";
import { DotLoader } from "react-spinners";

import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import PropTypes from "prop-types";
import selectors from "./selectors";
import actions from "../../actions";
import { paths } from "../../../../../common/constants";
import graph from "../../../common/utils/graph";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      transaction_range: 2,
      post_range: 2,
      upload_range: 2,

      customers_num: 0,
      posts: [],
      posts_num: 0,
      top_customers: [],
      top_posts: [],
      top_countries: [],
      transactions: [],
      transactions_num: 0,
      upload_videos: [],
      upload_images: [],
      pending_transactions: 0,
      cancelled_transactions: 0,
      completed_transactions: 0,
      suspended_transactions: 0,

      //generated graphs
      post_graph: null,
      transaction_graph: null,
      images_videos_graph: null,

      chart_opt: {
        tooltips: {
          enabled: false,
          intersect: true,
          mode: "index",
          position: "nearest",
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].borderColor,
              };
            },
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              stacked: false,
              ticks: {
                min: 0,
                stepSize: 2,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      },
      transaction_date: moment().toDate(),
      post_date: moment().toDate(),
      upload_date: moment().toDate(),
    };

    this.onTransactionRange = this.onTransactionRange.bind(this);
    this.onPostRange = this.onPostRange.bind(this);
    this.onUploadRange = this.onUploadRange.bind(this);
    this.handleViewPage = this.handleViewPage.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
  }

  componentDidMount() {
    const {
      getDashboardData,
      getTransactionGraph,
      getPostGraph,
      getUploadGraph,
    } = this.props;
    const {
      transaction_range,
      post_range,
      upload_range,
      transaction_date,
      post_date,
      upload_date,
    } = this.state;

    getDashboardData()
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const {
            customers_num,
            posts_num,
            top_customers,
            top_posts,
            top_countries,
            transactions_num,
            pending_transactions,
            cancelled_transactions,
            completed_transactions,
          } = data;
          this.setState({
            customers_num,
            posts_num,
            top_customers,
            top_countries,
            top_posts,
            transactions_num,
            pending_transactions,
            cancelled_transactions,
            completed_transactions,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Internal Server Error");
      });

    getTransactionGraph({ transaction_range: 3, transaction_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { transactions } = data;
          const transaction_graph = graph.convertDataToGraph(
            transactions,
            transaction_range,
            "Transactions Data",
            transaction_date
          );

          this.setState({ transactions, transaction_graph });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getPostGraph({ post_range: 3, post_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { posts } = data;
          const post_graph = graph.convertDataToGraph(
            posts,
            post_range,
            "Posts Data",
            post_date
          );
          this.setState({ posts, post_graph });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Internal Server Error");
      });

    getUploadGraph({ upload_range: 3, upload_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { upload_videos, upload_images } = data;
          const images_videos_graph = graph.convertTwoGraph(
            upload_videos,
            upload_images,
            "Videos",
            "Images",
            upload_range,
            upload_date
          );

          this.setState({ images_videos_graph, upload_videos, upload_images });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Internal Server Error");
      });
  }

  handleChangeDate(type, date) {
    const { getTransactionGraph, getPostGraph, getUploadGraph } = this.props;
    const { transaction_range, post_range, upload_range } = this.state;
    if (type === "uploads") {
      this.setState({
        upload_date: date,
      });

      getUploadGraph({ upload_range, upload_date: date })
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            const { upload_videos, upload_images } = data;
            const images_videos_graph = graph.convertTwoGraph(
              upload_videos,
              upload_images,
              "Videos",
              "Images",
              upload_range,
              date
            );

            this.setState({
              images_videos_graph,
              upload_videos,
              upload_images,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Internal Server Error");
        });
    } else if (type === "posts") {
      this.setState({
        post_date: date,
      });
      getPostGraph({ post_range, post_date: date })
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            const { posts } = data;
            const post_graph = graph.convertDataToGraph(
              posts,
              post_range,
              "Posts Data",
              date
            );
            this.setState({ posts, post_graph });
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Internal Server Error");
        });
    } else if (type === "transactions") {
      this.setState({
        transaction_date: date,
      });
      getTransactionGraph({ transaction_range, transaction_date: date })
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            const { transactions } = data;
            const transaction_graph = graph.convertDataToGraph(
              transactions,
              transaction_range,
              "Transactions Data",
              date
            );

            this.setState({ transactions, transaction_graph });
          }
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    }
  }

  handleViewPage(view) {
    const {
      history: { push },
    } = this.props;
    if (view === "customers") {
      push(paths.client.ADMIN_CUSTOMERS);
    } else if (view === "transactions") {
      push(paths.client.ADMIN_TRANSACTIONS);
    } else if (view === "posts") {
      push(paths.client.ADMIN_POSTS);
    }
  }

  onTransactionRange(radioSelected) {
    const { transaction_date } = this.state;
    const { getTransactionGraph } = this.props;

    getTransactionGraph({ transaction_range: radioSelected, transaction_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { transactions } = data;
          const transaction_graph = graph.convertDataToGraph(
            transactions,
            radioSelected,
            "Transactions Data",
            transaction_date
          );

          this.setState({
            transaction_range: radioSelected,
            transactions,
            transaction_graph,
          });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  onPostRange(radioSelected) {
    const { post_date } = this.state;
    const { getPostGraph } = this.props;
    getPostGraph({ post_range: radioSelected, post_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { posts } = data;
          const post_graph = graph.convertDataToGraph(
            posts,
            radioSelected,
            "Transactions Data",
            post_date
          );

          this.setState({ post_range: radioSelected, posts, post_graph });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  onUploadRange(radioSelected) {
    const { upload_date } = this.state;
    const { getUploadGraph } = this.props;

    getUploadGraph({ upload_range: radioSelected, upload_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { upload_videos, upload_images } = data;
          const images_videos_graph = graph.convertTwoGraph(
            upload_videos,
            upload_images,
            "Videos",
            "Images",
            radioSelected,
            upload_date
          );

          this.setState({
            images_videos_graph,
            upload_videos,
            upload_images,
            upload_range: radioSelected,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Internal Server Error");
      });
  }

  renderCardInfoRow() {
    const { customers_num, posts_num, transactions_num } = this.state;
    return (
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card text-white bg-info">
            <div className="card-body pb-0">
              <div className="text-value">{customers_num}</div>
              <div className="text-card-title">Customers</div>
            </div>
            <div className="redirect-link-container">
              <div
                className="redirect-link customers"
                onClick={() => this.handleViewPage("customers")}
              >
                View
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card text-white bg-warning">
            <div className="card-body pb-0">
              <div className="text-value">{posts_num}</div>
              <div className="text-card-title">Posts</div>
            </div>
            <div className="redirect-link-container">
              <div
                className="redirect-link posts"
                onClick={() => this.handleViewPage("posts")}
              >
                View
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card text-white bg-danger">
            <div className="card-body pb-0">
              <div className="text-value">{transactions_num}</div>
              <div className="text-card-title">Transactions</div>
            </div>
            <div className="redirect-link-container">
              <div
                className="redirect-link transactions"
                onClick={() => this.handleViewPage("transactions")}
              >
                View
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderMapView() {
    return (
      <GoogleMapReact
        defaultCenter={this.props.center}
        defaultZoom={this.props.zoom}
      ></GoogleMapReact>
    );
  }

  renderTransactionGraph() {
    const {
      transaction_range,
      transaction_graph,
      chart_opt,
      pending_transactions,
      suspended_transactions,
      cancelled_transactions,
      completed_transactions,
      transaction_date,
    } = this.state;

    const transactions = {
      labels: ["Pending", "Suspended", "Cancelled", "Completed"],
      datasets: [
        {
          data: [
            pending_transactions,
            suspended_transactions,
            cancelled_transactions,
            completed_transactions,
          ],
          backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
        },
      ],
    };

    return (
      <div className="row">
        <div className="col-12 col-sm-8 col-lg-8">
          <div className="card graph-card">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12 col-xl-4">
                  <CardTitle className="mb-0">Transactions</CardTitle>
                  <DatePicker
                    className="form-control graph-date-picker"
                    selected={transaction_date}
                    onChange={(date) =>
                      this.handleChangeDate("transactions", date)
                    }
                  />
                </div>
                <div className="col-sm-12 col-xl-8">
                  <ButtonToolbar
                    className="float-right"
                    aria-label="Toolbar with button groups"
                  >
                    <ButtonGroup className="mr-3" aria-label="First group">
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onTransactionRange(1)}
                        active={transaction_range === 1}
                      >
                        Day
                      </Button>
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onTransactionRange(2)}
                        active={transaction_range === 2}
                      >
                        Month
                      </Button>
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onTransactionRange(3)}
                        active={transaction_range === 3}
                      >
                        Year
                      </Button>
                    </ButtonGroup>
                  </ButtonToolbar>
                </div>
              </div>
              <div className="chart-wrapper">
                {transaction_graph ? (
                  <Line
                    data={transaction_graph}
                    options={chart_opt}
                    height={120}
                  />
                ) : (
                  <DotLoader sizeUnit={"px"} size={50} color={"#00DD8C"} />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-4 col-lg-4">
          <div className="card">
            <div className="card-body">
              <h2>Transactions Status</h2>
              <div
                className="chart-wrapper"
                style={{ height: 300 + "px", marginTop: 40 + "px" }}
              >
                <Pie
                  data={transactions}
                  width={100}
                  height={100}
                  options={{ maintainAspectRatio: false }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPostMediasGraph() {
    const {
      post_range,
      upload_range,
      post_graph,
      chart_opt,
      images_videos_graph,
      post_date,
      upload_date,
    } = this.state;
    return (
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-6">
          <div className="card graph-card">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12 col-xl-4">
                  <CardTitle className="mb-0">Posts</CardTitle>
                  <DatePicker
                    className="form-control"
                    selected={post_date}
                    onChange={(date) => this.handleChangeDate("posts", date)}
                  />
                </div>
                <div className="col-sm-12 col-xl-8">
                  <ButtonToolbar
                    className="float-right"
                    aria-label="Toolbar with button groups"
                  >
                    <ButtonGroup className="mr-3" aria-label="First group">
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onPostRange(1)}
                        active={post_range === 1}
                      >
                        Day
                      </Button>
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onPostRange(2)}
                        active={post_range === 2}
                      >
                        Month
                      </Button>
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onPostRange(3)}
                        active={post_range === 3}
                      >
                        Year
                      </Button>
                    </ButtonGroup>
                  </ButtonToolbar>
                </div>
              </div>
              <div className="chart-wrapper">
                {post_graph ? (
                  <Line data={post_graph} options={chart_opt} height={120} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-6">
          <div className="card graph-card">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12 col-xl-4">
                  <CardTitle className="mb-0">
                    Uploaded Images & Videos
                  </CardTitle>
                  <DatePicker
                    className="form-control"
                    selected={upload_date}
                    onChange={(date) => this.handleChangeDate("uploads", date)}
                  />
                </div>
                <div className="col-sm-12 col-xl-8">
                  <ButtonToolbar
                    className="float-right"
                    aria-label="Toolbar with button groups"
                  >
                    <ButtonGroup className="mr-3" aria-label="First group">
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onUploadRange(1)}
                        active={upload_range === 1}
                      >
                        Day
                      </Button>
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onUploadRange(2)}
                        active={upload_range === 2}
                      >
                        Month
                      </Button>
                      <Button
                        color="outline-secondary"
                        onClick={() => this.onUploadRange(3)}
                        active={upload_range === 3}
                      >
                        Year
                      </Button>
                    </ButtonGroup>
                  </ButtonToolbar>
                </div>
              </div>
              <div className="chart-wrapper" style={{ height: 300 + "px" }}>
                {images_videos_graph ? (
                  <Bar
                    data={images_videos_graph}
                    width={100}
                    height={50}
                    options={{
                      maintainAspectRatio: false,
                    }}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTopRatedPosts() {
    const { top_posts } = this.state;
    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Table
                hover
                responsive
                className="table-outline mb-0 d-none d-sm-table"
              >
                <thead className="thead-light">
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Price</th>
                    <th>Likes</th>
                  </tr>
                </thead>
                <tbody>
                  {top_posts.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{item.title}</td>
                        <td>{item.description}</td>
                        <td>{item.price}</td>
                        <td>{item.likes}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTopUsers() {
    const { top_customers } = this.state;

    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Table
                hover
                responsive
                className="table-outline mb-0 d-none d-sm-table"
              >
                <thead className="thead-light">
                  <tr>
                    <th className="text-center">
                      <i className="fa fa-user"></i>
                    </th>
                    <th>User</th>
                    <th className="text-center">Email</th>
                    <th>Posts Count</th>
                  </tr>
                </thead>
                <tbody>
                  {top_customers.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td className="text-center">
                          <img src={item.avatar} className="user-avatar"></img>
                        </td>
                        <td>{item.username}</td>
                        <td className="text-center">{item.email}</td>
                        <td>{item.posts}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTopCountries() {
    const { top_countries } = this.state;

    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Table
                hover
                responsive
                className="table-outline mb-0 d-none d-sm-table"
              >
                <thead className="thead-light">
                  <tr>
                    <th>Country</th>
                    <th className="text-center">City</th>
                    <th className="text-center">Posts Count</th>
                  </tr>
                </thead>
                <tbody>
                  {top_countries.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{item.country}</td>
                        <td className="text-center">{item.city}</td>
                        <td className="text-center">{item.post_count}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTabView() {
    return (
      <Tabs>
        <TabList>
          <Tab>{"Top Rated Posts"}</Tab>
          <Tab>{"Top Users"}</Tab>
          <Tab>{"Top Countries"}</Tab>
        </TabList>

        <TabPanel>{this.renderTopRatedPosts()}</TabPanel>
        <TabPanel>{this.renderTopUsers()}</TabPanel>
        <TabPanel>{this.renderTopCountries()}</TabPanel>
      </Tabs>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content dashboard-page">
          {this.renderCardInfoRow()}
          {this.renderTransactionGraph()}
          {this.renderPostMediasGraph()}
          {this.renderTabView()}
        </div>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  center: PropTypes.array,
  zoom: PropTypes.number,
  getDashboardData: PropTypes.func,
  getTransactionGraph: PropTypes.func,
  getPostGraph: PropTypes.func,
  getUploadGraph: PropTypes.func,
};

Dashboard.defaultProps = {
  center: [59.938043, 30.337157],
  zoom: 9,
};

export default connect(selectors, {
  ...actions.dashboard,
})(withRouter(Dashboard));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Dashboard/index.js